import ImageOverlay from 'components/token-town/shared/image-overlay/ImageOverlay';
import TokenRedemptionCostPill from 'components/token-town/TokenRedemptionCostPill';
import { ReactNode, useState } from 'react';
import styles from './ImageGallery.module.css';

type ImageGalleryProps = {
  tokenCost: number;
  images: (string | undefined | null)[];
  heroFooter?: ReactNode;
};

export default function ImageGallery({
  tokenCost,
  images,
  heroFooter,
}: ImageGalleryProps) {
  const [active, setActive] = useState(0);

  if (!images.length) return null;

  return (
    <section className={styles.gallery}>
      {/* hero */}
      <div className={styles.heroWrapper}>
        <div className={styles.tokenCost}>
          <TokenRedemptionCostPill redemptionCost={tokenCost} />
        </div>
        <img src={images[active] ?? undefined} className={styles.hero} alt="" />
        <ImageOverlay />
        {heroFooter && <div className={styles.heroFooter}>{heroFooter}</div>}
      </div>
      {/* thumbs */}
      {images.filter((img) => img).length > 1 && (
        <div className={styles.thumbRow}>
          {images
            .filter((img) => img)
            .map((src, i) => (
              <button
                key={i}
                className={`${styles.thumbBtn} ${i === active ? styles.active : ''}`}
                onClick={() => setActive(i)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') setActive(i);
                }}
              >
                <img
                  src={src ?? undefined}
                  alt=""
                  className={styles.thumbImg}
                />
                <ImageOverlay />
              </button>
            ))}
        </div>
      )}
    </section>
  );
}